<template>
    <div>
        <b-container>
            <div>
                <b-card-body>
                    <b-row align-v="end">
                        <b-col cols="4">
                            <div class="pt-0">
                                <h2>Atrativo</h2>
                            </div>
                        </b-col>

                        <b-col cols="8">
                            <div class="pt-0">
                                <h4><b>{{ form.atrativo.product_name }}</b></h4>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row align-v="end">
                        <b-col cols="4">
                            <div class="pt-0">
                                <h4>Agendado para</h4>
                            </div>
                        </b-col>

                        <b-col cols="8">
                            <div class="pt-0">
                                <h4><b>{{ formattedDate + " " + form.time }}</b></h4>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row align-v="end">
                        <b-col cols="4">
                            <div class="pt-0">
                                <h4>Tipo de Reserva</h4>
                            </div>
                        </b-col>

                        <b-col cols="8">
                            <div class="pt-0">
                                <h4><b>{{ form.booking_name }}</b></h4>
                            </div>
                        </b-col>
                    </b-row>

                    <hr>

                    <b-row align-v="start">
                        <b-col cols="4">
                            <div class="pt-0">
                                <h2>Ingressos</h2>
                            </div>
                        </b-col>

                        <b-col cols="8">
                            <div v-for="(ticket, idx) in ticketsSummary" :key="idx">
                                <h4 v-if="ticket.quantity > 0">
                                    <b> {{ticket.name }}</b>
                                        {{ ' (' + ticket.quantity + ' x ' + ticket.value.toFixed(2).replace('.', ',') + ')' + ': R$' + (ticket.value * ticket.quantity).toFixed(2).replace('.', ',') }}
                                </h4>
                            </div>
                            <hr>

                            <div align-h="end">
                                <h4><b> Total: </b> {{ (new Number(totalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }} </h4>
                            </div>
                        </b-col>
                    </b-row>
                    <hr>

                    <b-row align-v="start">
                        <b-col cols="4">
                            <div class="pt-0">
                                <h2>Dados</h2>
                            </div>
                        </b-col>

                        <b-col>
                            <h4>Nome: <b>{{ form.name }}</b></h4>
                            <h4>Telefone: <b>{{ form.phone }}</b></h4>
                        </b-col>
                    </b-row>
                </b-card-body>
            </div>

            <b-navbar class="floating-nav" style="background-color: #fff">
                <b-navbar-nav>
                    <b-button @click="prev()" variant="primary" class="mt-0 rounded-pill" style="border-color: #22A06B; padding-top: 7px; padding-bottom: 7px">Voltar</b-button>
                </b-navbar-nav>

                <b-navbar-nav >
                    <b-button @click="askResetForm()" variant="danger" class="mt-0 rounded-pill" style="padding-top: 7px; padding-bottom: 7px">Cancelar</b-button>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-button @click="reservar()" :disabled="disabledButton" type="submit" variant="success" class="mt-0 rounded-pill"style="background-color: #22A06B; border-color: #22A06B; padding-top: 7px; padding-bottom: 7px">Pagar</b-button>
                </b-navbar-nav>
            </b-navbar>
        </b-container>

        <PagamentoModal v-if="isModalPagamentoOpen" @closePagamentoModal="closePagamentoModal" :PAYMENT_STATUS="PAYMENT_STATUS" :isModalPagamentoOpen="isModalPagamentoOpen">
        </PagamentoModal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import moment from "moment"
import swal from "sweetalert2"
import qrcodeVue from "qrcode.vue"
import PagamentoModal from "./PagamentoModal.vue";
import useManageReservaExpressa from "../../Composables/useManageReservaExpressa"

export default {
    component: 'PagamentoResumo',

    components: {
        PagamentoModal,
        qrcodeVue
    },

    setup(props, context) {
        const manageReservaExpressa = useManageReservaExpressa(context)

        function calculateTotalCost(){ return manageReservaExpressa.calculateTotalCost() }
        function setTickets(items) { return manageReservaExpressa.setTickets(items) }

        return {
            calculateTotalCost, setTickets,
        }
    },

    props:{
        PAYMENT_STATUS: {
            type: String,
            default: '' | null
        },
    },

    data() {
        return {
            isModalPagamentoOpen: false,
        }
    },

    watch: {

        ['form.tickets'](newValue, oldValue){
            this.setTickets(newValue)
        },
    },

    computed: {
        ...mapGetters('booking',{
            form: 'getReservaForm',
        }),

        ticketsSummary() {
            var vm = this
            return Object.values(this.form.tickets).map(function (val, idx) {
                var quantity = Number(val.quantity)
                var price = val.price != null && val.price != undefined ? parseFloat(val.price.replace(/[^0-9.]/g, ".")) : 0

                if (quantity > 0) {
                    return {
                        name: val.label != null && val.label != undefined && val.label.length > 0 ? val.label : val.booking_name,
                        description: vm.form.booking_name + "-" + val.label,
                        value: Number(price.toFixed(2)),
                        quantity: parseInt(val.quantity),
                        sku: "",
                    }
                }
            }).filter(i => i != undefined)
        },

        disabledButton(){
            return (this.form.name.length == 0 || this.form.name.length < 2) || (this.form.phone.length == 0 || this.form.phone.length < 14) ? true : false
        },

        totalCost(){ return this.calculateTotalCost() },

        //TODO use utils.general.formatDate
        formattedDate(){ return moment(this.form.date).format('DD/MM/YYYY') },
    },

    methods: {
        ...mapActions('booking', [
            "createExpressBooking",
            "bookingStoreCommit",
        ]),

        closePagamentoModal(){ this.isModalPagamentoOpen = false },

        prev() { this.$emit('goToSection', 'dados') },

        askResetForm() {
            swal.fire({
                text: "Cancelar compra?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, cancelar',
                confirmButtonClass: 'btn btn-warning',
                confirmButtonColor: '#DD6B55',
                cancelButtonText: 'Continuar comprando',
                reverseButtons: true,
                cancelButtonColor: 'primary',
                type: 'warning'
            })
            .then((result => {
                if (result.isConfirmed) {
                    this.resetFormData()
                    this.$emit('goToSection', 'ingressos')
                }
            }))
        },

        resetFormData(){
            this.$emit('resetPaymentStatus', null)
            this.bookingStoreCommit({mutation: 'RESET_FORM_STANDART_DATA', value: this.form})
            this.bookingStoreCommit({mutation: 'SET_RESERVA_FORM', value: this.form})
        },

        reservar(){
            // const QUERY = Object.keys(this.$route.query)[0]
            // this.form.return_url = window.location.origin + "/booking/?" + QUERY
            this.form.gateway = 'EXPRESSBOOKING'
            this.isModalPagamentoOpen = true
            this.createExpressBooking(this.form)
        },
    },

    mounted() {
        if (process.env.NODE_ENV !== 'production' || this.$route.query.debug == 'true' ) {
          window.jdebug = this
        }

        this.setTickets(this.form.tickets)
    },
}

</script>

<style scoped>
    hr{
        margin-top: 0;
        margin-bottom: 3%;
    }

    .floating-nav {
        width: 400px;
        height: auto;
        background: #ffffff;
        border: 1px solid #DBDBDB;
        border-radius: 12px 12px 0 0px;
        padding: 15px;
        z-index: 999;
        position: fixed;
        bottom: 0;
        left: 50%;
        justify-content: space-between;
        transform: translateX(-50%);
    }

    @media screen and (max-width: 870px) {
    .floating-nav {
        width: 100%;
        height: auto;
        background: #ffffff;
        border: 1px solid #DBDBDB;
        padding: 15px;
        z-index: 999;
        position: fixed;
        bottom: 0;
        left: 50%;
        justify-content: space-between;
        transform: translateX(-50%);
    }

    }
</style>
